import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Time from "../../assets/TimingBelt.jpg";

const TimingBeltReplacement = () => {
  return (
    <>
      <SeoHead
        title="Timing Belt Replacement in Temecula | Advanced Automotive Smog"
        description="Timing belt inspection and replacement in Temecula to help prevent the internal engine damage that can follow a worn or failed belt."
        path="/services/timing-belt-replacement"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Timing Belt Replacement"
          path="/services/timing-belt-replacement"
          description="Timing belt inspection and replacement in Temecula to help prevent the internal engine damage that can follow a worn or failed belt."
          serviceType="Timing belt replacement"
        />
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Time}
                alt="Timing Belt Replacement"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Section */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Engine Protection
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Timing Belt Replacement
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Avoid costly engine damage with our expert timing belt replacement
              service. A worn timing belt can fail without warning, leading to
              major repairs — we help keep your engine safe and reliable.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is a Timing Belt?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              The timing belt synchronizes the camshaft and crankshaft so your
              valves and pistons move in perfect harmony. If it breaks, it can
              cause severe internal engine damage.
              <br />
              <br />
              Our service includes full timing belt inspection, precise
              replacement, and reassembly using high-quality parts to restore
              safe and efficient engine operation.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Expert timing belt inspection & diagnosis
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                High-quality, durable replacement belts
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Prevents catastrophic engine failure
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Restores optimal engine timing and performance
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                Installed by highly skilled technicians
              </li>
            </ul>

            {/* Button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>
          </div>

        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default TimingBeltReplacement;
